import { useCompany } from "@/api/services/admin/company";
import { useCompanyUserList } from "@/api/services/admin/company/user";
import { TGetUserListDto } from "@/api/services/admin/company/user/dtos/get-user-list.dto";
import { useEnum } from "@/api/services/global/enum";
import { Table } from "@/components/elements/Table";
import { DATE_TIME_FORMAT } from "@/constants/datetime";
import { EMPTY_STR } from "@/constants/string";
import { useTable } from "@/hooks/useTable";
import { dayjs } from "@/utils/dayjs";
import { findLabelByValue } from "@/utils/object";
import { Stack, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";

export const CompanyUserTable = () => {
  const { data: userActiveStatuses } = useEnum("EUserActiveStatus");
  const { data: companyUserListResult, isLoading } = useCompanyUserList();
  const companyUserListData = companyUserListResult?.data;

  const columns = useMemo<MRT_ColumnDef<TGetUserListDto>[]>(
    () => [
      {
        header: "ユーザー名",
        id: "fullName",
        accessorKey: "fullName",
      },
      {
        header: "メールアドレス",
        id: "email",
        accessorKey: "email",
      },
      {
        header: "所属",
        size: 120,
        Cell: ({ row }) => (row.original.isCompanyUser ? "企業ユーザー" : "irohana担当者"),
      },
      {
        header: "ステータス",
        size: 120,
        Cell: ({ row }) => (row.original.activeStatus ? findLabelByValue(userActiveStatuses, row.original.activeStatus) : EMPTY_STR.TEXT),
      },
      {
        header: "最終ログイン日時",
        id: "lastLoginAt",
        Cell: ({ row }) => (row.original.lastLoginAt ? dayjs(row.original.lastLoginAt).format(DATE_TIME_FORMAT) : EMPTY_STR.DATE_TIME),
        size: 120,
      },
    ],
    [userActiveStatuses],
  );

  const { table } = useTable({ columns, rows: companyUserListData ?? [], pinningColumns: ["manager", "edit"] });

  return (
    <Stack gap={1}>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="sub16Bold">企業ユーザー</Typography>
      </Stack>
      <Table table={table} isLoading={isLoading} />
    </Stack>
  );
};
